import axios from "axios";
import { baseApiUrl } from "@/environment";

export const fetchEventTables = (eventRequest) =>
  axios.post(baseApiUrl + "/GetEventTables", eventRequest);

export const saveEventTables = (eventUpdate) =>
  axios.post(baseApiUrl + "/UpdateEventTables", eventUpdate);
